import React,{Component} from 'react';
import WebHeaderInner from './WebHeaderInner.js';
import WebFooter from './WebFooter.js';
//import {Modal} from 'react-bootstrap';
import './App.css';
import $ from 'jquery';
const baseUrl='https://aquadeals.in/admin/web3/user/';
// const baseAssets='https://aquadeals.in/admin/assets/';

export default class Web_Site_Map extends Component{
  constructor(props){	
    super(props);
    this.state={
    	todos: [],
      isLoaded: false,
    }
  }

  componentDidMount()
  {
      $.ajax({
      url: baseUrl+"web_site_map",
      dataType: "json",
      success: function(data){
        this.setState({
                    todos:data
        });
      }.bind(this)

    });


  }

  render()
  {
  	var categories = $.makeArray(this.state.todos.products);


  	let categories_list = categories.map((list,index) =>
    <li key={index}>      
            <h1 className="list_hdg">{list.cname}</h1>     
        <ul className="list_blk">
        {list.scat.map((sclist,index1 ) => 
          <li key={index1}><a href={sclist.sclink} >{sclist.scname}</a></li>
        )}
        </ul>
    </li>

  );   
    document.title ="AquaDeals - Online AquaCulture MarketPlace, Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
      document.getElementsByTagName("META")[2].content="It is a place for deals related to Aqua culture";
	return(
		<div>	
			<WebHeaderInner />	
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			 <div className="clr">&nbsp;</div>
			   <div className="container web_advertise_page" >	 
			     <div className="row">
			  
					<div align="center">
						<h1 className="st_mp_hdg">Catalogue</h1>  
			        	<ul className="myclass">{categories_list}</ul>
			      </div>
             </div>  
			     </div> 
		    <WebFooter />
     </div>
	);
  }
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_Site_Map.js
 **/